<script>
import Games from "@/services/Games";

export default {
  props: {
    customerId: {
      type: [String, Number],
      required: true,
    },
    gameId: {
      type: [String, Number],
      required: true,
    },
    currentStreak: {
      type: [String, Number],
      default: 0,
    },
  },
  data() {
    return {
      streak: this.currentStreak,
      tryingToSubmit: false,
      error: "",
    };
  },
  watch: {
    currentStreak(newVal) {
      this.streak = newVal;
    },
  },
  methods: {
    closeModal() {
      this.$bvModal.hide("edit_mini_game_streak");
      this.error = "";
      this.tryingToSubmit = false;
    },
    async saveStreak() {
      this.tryingToSubmit = true;
      this.error = "";

      try {
        const payload = {
          customer_id: this.customerId,
          game_id: this.gameId,
          streak: this.streak,
        };

        const response = await Games.updateMiniGamesStreak(payload);
        if (response.data && response.data.success) {
          this.$emit("onRefresh");
          this.closeModal();
        } else {
          this.error =
            (response.data && response.data.error) ||
            "Failed to update streak";
        }
      } catch (e) {
        this.error =
          e.response?.data?.error ||
          e.response?.data?.message ||
          "Failed to update streak";
      } finally {
        this.tryingToSubmit = false;
      }
    },
  },
};
</script>

<template>
  <b-modal
    id="edit_mini_game_streak"
    title="Edit Streak"
    size="md"
    centered
    @hidden="closeModal"
  >
    <template v-slot:default>
      <div class="row">
        <div class="col-12">
          <b-form-group label="Streak">
            <b-form-input
              type="number"
              min="0"
              v-model="streak"
            />
          </b-form-group>
          <p v-if="error" class="text-danger mb-0">{{ error }}</p>
        </div>
      </div>
    </template>

    <template v-slot:modal-footer>
      <b-button variant="light" @click="closeModal">Cancel</b-button>
      <b-button
        variant="primary"
        @click="saveStreak"
        :disabled="tryingToSubmit"
      >
        <b-spinner v-if="tryingToSubmit" small class="me-1" />
        Save
      </b-button>
    </template>
  </b-modal>
</template>

